export const environment = {
  production: false,
  // @brafton/feedback-api origin (WITHOUT the /api/v1 prefix — provideFeedbackApi adds it).
  apiBaseUrl: 'https://feedback-api.dev.tech.brafton.com',
  // Feedback app origin — hosts the /auth-bridge page and the Sign in destination.
  appBaseUrl: 'https://feedback.dev.tech.brafton.com',
  // Sentry: one project DSN across environments; `name` tags the Sentry environment.
  sentryDsn: 'https://942cb6bf4d2bb208ba3e1f4106d37b2e@o4511258258898944.ingest.us.sentry.io/4511514089029632',
  name: 'development'
};
